// Import dependencies
import { unsafeCSS, css, html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';

// Import escapeHTML
import { escapeHTML } from '@wordpress/escape-html';

// Import i18n functions
import { __ } from '@wordpress/i18n';

// Import recipe builder services
import { setRecipeStatus } from '@automator/builder/services';

// Import style for web component
import styles from './web-component-style.scss?inline';

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-builder-publish-status-toggle' )
export class AutomatorBuilderPublishStatusToggle extends LitElement {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	// eslint-disable-next-line require-jsdoc
	render() {
		// Only render the button is the recipe DOES NOT have the "Run now" button
		if ( UncannyAutomator._recipe.miscellaneous.has_run_now ) {
			return;
		}

		return html`
			<uo-field-input-switch
				size="large"

				?checked=${ UncannyAutomator._recipe.is_recipe_on }

				label-on=${ escapeHTML( __( 'Live', 'uncanny-automator' ) ) }
				label-off=${ escapeHTML( __( 'Draft', 'uncanny-automator' ) ) }
				label-placement="left"
				
				.processChangeRequest=${ async isChecked => {
					return setRecipeStatus( isChecked );
				} }
			></uo-field-input-switch>
		`;
	}
}